<template>
  <div>
    <template v-if="disabled">
      <span class="text-primary">{{ data | dateTimeFormat }}</span>
    </template>
    <a-date-picker
      v-else
      v-model="data"
      :disabled="disabled"
      :disabled-date="disabledDate"
      format="DD MMM YYYY"
      valueFormat="YYYY-MM-DD"
      :placeholder="
        option.placeholder
          ? option.placeholder
          : $t('_components.placeholder.input') + label
      "
    />
    <!-- <flat-pickr
      v-else
      v-model="data"
      :disabled="disabled"
      :max-date="option.maxDate || null"
      :min-date="option.minDate || null"
      :placeholder="
        option.placeholder
          ? option.placeholder
          : $t('_components.placeholder.input') + label
      "
      class="form-control"
      :config="config"
    /> -->
  </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
  },
  filters: {
    dateTimeFormat(date) {
      if (date) {
        const resDate = moment(date).format('DD MMM YYYY')
        return resDate
      }
      return ''
    },
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      config: {
        enableTime: false,
        // dateFormat: 'd M Y',
        dateFormat: 'Y-m-d',
        allowInput: true,
        minDate: '',
        maxDate: '',
      },
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
    'option.minDate': {
      handler(e) {
        this.config.minDate = e
      },
      deep: true,
      immediate: true,
    },
    'option.maxDate': {
      handler(e) {
        this.config.maxDate = e
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initComponent()
  },
  methods: {
    initComponent() {
      this.config.minDate = this.option.minDate
      this.config.maxDate = this.option.maxDate
    },
    disabledDate(e) {
      if (!e) return false
      const current = moment(e)
      const beforeMin =
        this.config.minDate &&
        current.isBefore(moment(this.config.minDate), 'day')
      const afterMax =
        this.config.maxDate &&
        current.isAfter(moment(this.config.maxDate), 'day')
      return beforeMin || afterMax
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .ant-calendar-picker {
  width: 100%;
  .ant-input {
    height: 38px;
  }
}
</style>
